const breadCrumb = "Consultas e Relatórios de Apoio - Consultas e Relatórios";

const routes = [
  {
    path: "/consulta-faturamento",
    name: "consulta-faturamento",
    meta: {
      allowedPermissions: ["faturamento_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/Faturamento/ConsultaFaturamento/ConsultaFaturamentoHome.vue"
      ),
  },
];

export default routes;
